/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Async state management actions
 *
 * @author Yakov Gushchin
 * @version 1.11.0
 * @since 1.11.0
 */

import { createAction } from '../app/createAction';
import {
    ASYNC_STATE_MANAGEMENT_INIT,
    ASYNC_STATE_MANAGEMENT_INIT_SUCCESS,
    ASYNC_STATE_MANAGEMENT_SAVE,
    ASYNC_STATE_MANAGEMENT_UNMOUNT,
    ASYNC_STATE_MANAGEMENT_UNMOUNT_SUCCESS,
} from './asyncStateManagementConstants';
import {
    IAsyncStateManagementInitPayload,
    IAsyncStateManagementInitSuccessPayload,
    IAsyncStateManagementSavePayload,
    TAsyncStateManagementInitAction,
    TAsyncStateManagementInitSuccessAction,
    TAsyncStateManagementSaveAction,
    TAsyncStateManagementUnmountAction,
    TAsyncStateManagementUnmountSuccessAction,
} from './asyncStateManagementTypes';

/*
* -------------------------------------------
*           INIT & UNMOUNT
* -------------------------------------------
*/

export const asyncStateManagementInitAction =
    (payload: IAsyncStateManagementInitPayload): TAsyncStateManagementInitAction =>
        createAction(ASYNC_STATE_MANAGEMENT_INIT, payload);

export const asyncStateManagementInitSuccessAction = (payload: IAsyncStateManagementInitSuccessPayload):
    TAsyncStateManagementInitSuccessAction =>
    createAction(ASYNC_STATE_MANAGEMENT_INIT_SUCCESS, payload);

export const asyncStateManagementUnmountAction = (payload: string): TAsyncStateManagementUnmountAction =>
    createAction(ASYNC_STATE_MANAGEMENT_UNMOUNT, payload);

export const asyncStateManagementUnmountSuccessAction = (payload: string): TAsyncStateManagementUnmountSuccessAction =>
    createAction(ASYNC_STATE_MANAGEMENT_UNMOUNT_SUCCESS, payload);

/*
* -------------------------------------------
*           Save state
* -------------------------------------------
*/

export const asyncStateManagementSaveAction =
    (payload: IAsyncStateManagementSavePayload): TAsyncStateManagementSaveAction =>
        createAction(ASYNC_STATE_MANAGEMENT_SAVE, payload);
